import { render, staticRenderFns } from "./PuntodeVenta.vue?vue&type=template&id=732ba752&scoped=true"
import script from "./PuntodeVenta.vue?vue&type=script&lang=js"
export * from "./PuntodeVenta.vue?vue&type=script&lang=js"
import style0 from "./PuntodeVenta.vue?vue&type=style&index=0&id=732ba752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732ba752",
  null
  
)

export default component.exports